module.exports = __webpack_public_path__ + "static/media/logo.f037e491.svg";